// extracted by mini-css-extract-plugin
module.exports = {"lead":"lead-details_lead__1J50u","gridContainer":"lead-details_gridContainer__LhvKW","column":"lead-details_column__3KIIu","leadLine":"lead-details_leadLine__101Us"};